import { render, staticRenderFns } from "./CriticalWorkFunctions.vue?vue&type=template&id=77234407&scoped=true"
import script from "./CriticalWorkFunctions.vue?vue&type=script&lang=ts"
export * from "./CriticalWorkFunctions.vue?vue&type=script&lang=ts"
import style0 from "./CriticalWorkFunctions.vue?vue&type=style&index=0&id=77234407&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77234407",
  null
  
)

export default component.exports